import { render, staticRenderFns } from "./databaseBackup.vue?vue&type=template&id=a952699e"
import script from "./databaseBackup.vue?vue&type=script&lang=js"
export * from "./databaseBackup.vue?vue&type=script&lang=js"
import style0 from "./databaseBackup.vue?vue&type=style&index=0&id=a952699e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports